import React from "react";
import "./PageHeader.scss";

export default function PageHeader({ kicker, title, subtitle }) {
  return (
    <header className="page-hero-chassis fuel-fade-in">
      {kicker && <p className="page-hero-chassis__kicker">{kicker}</p>}
      <h1 className="page-hero-chassis__title">{title}</h1>
      {subtitle && <p className="page-hero-chassis__subtitle">{subtitle}</p>}
    </header>
  );
}
